import { LoadingStatusValues } from '@/utils/constants';

const resolveStatus = ({
  rawVal,
  setStatus,
  isSearch = false,
  enforceStatusUpdate = false,
}: StatusProps) => {
  const { initial, loading, ready } = LoadingStatusValues;
  const { isLoading = true, error = null } = rawVal;

  if (enforceStatusUpdate && isLoading) {
    const newStatus = error === null ? loading : ready;
    setTimeout(() => setStatus(newStatus), 500);
    return;
  }

  if (!isSearch) {
    const newStatus = initial;
    setTimeout(() => setStatus(newStatus), 500);
    return;
  }

  if (isLoading) {
    const newStatus = error === null ? loading : ready;
    setTimeout(() => setStatus(newStatus), 500);
    return;
  }

  setTimeout(() => setStatus(ready), 500);
};

export default resolveStatus;
